<template>
 <div class="pb-2">
   <div class="bg-theme-green border-0 rounded-t-xl px-4 py-2 text-white">
      <div class="flex justify-between items-center">
          <h2 class="font-semibold leading-tight truncate text-2xl mt-0">New Category</h2>
          <div class="flex flex-col">
              <div class="flex justify-end items-center">
                  <button @click.prevent="addNewCategory()" class="cursor-pointer rounded-md bg-white text-theme-green py-2 px-4 hover:bg-theme-darkgreen hover:text-white mr-3">
                     SAVE
                  </button>
                  <span @click.prevent="clearComponent" class="cursor-pointer rounded-md  text-white py-2 pl-1  hover:opacity-70">CLOSE</span>
                  <!-- <mdicon @click.prevent="clearComponent" size="32" name="close" class="cursor-pointer text-lg hover:opacity-60"/> -->
              </div>
          </div>
      </div>
  </div>


   <div class="pt-3 bg-[#2B2C32] px-[16px] py-[16px] rounded-lg">
      <div class="flex gap-5 xl:flex-row flex-col items-start mb-3">
          
          <div class="w-full xl:w-9/12">
            <div :class="'input-wrapper ' + (form.name.error_type)">
                <label class="text-xs mb-1">Name</label>
                <input v-model="form.name.value" @keyup="validateFields(['name'])" placeholder="E.g. Dried Flower" class="placeholder-theme-878686 block border-none rounded bg-gray-black w-full text-sm text-theme-white" type="text">
                <p class="field-error label-text mt-1" v-if="form.name.error_message" v-text="form.name.error_message"></p>
            </div>
          </div>

          <div class="w-full xl:w-3/12 flex xl:justify-end justify-start">
              <div class="input-wrapper">
                  <span class="mb-0 text-xs">Category Type</span>
                  <div class="flex mt-1">
                    <span @click="form.isSubCategory = false" :class="'cursor-pointer mr-2 text-sm font-medium ' + (form.isSubCategory ? 'text-theme-878686' : 'text-white')"> Main </span>
                      <label class="flex items-center cursor-pointer">
                        <input type="checkbox" v-model="form.isSubCategory" class="hidden peer">
                        <div :class="'relative toggle-bg  border-2  h-6 w-11 rounded-full bg-theme-green border-theme-green'"></div>
                      </label>
                    <span @click="form.isSubCategory = true" :class="'cursor-pointer ml-2 text-sm font-medium ' + (form.isSubCategory ? 'text-white' : 'text-theme-878686')"> Sub </span>
                  </div>
              </div>
          </div>
        </div>
        <div class="flex flex-row gap-5">
          <div v-if="globalLotSetting" class="xl:w-9/12">
            <div class="w-full w-full flex">
                <div class="input-wrapper">
                    <span class="mb-0 text-xs">Lot Tracking</span>
                    <div class="flex mt-1">
                      <span @click="form.lotTracking = false" :class="'cursor-pointer mr-2 text-sm font-medium ' + (form.lotTracking ? 'text-theme-878686' : 'text-white')"> Off </span>
                        <label class="flex items-center cursor-pointer">
                          <input type="checkbox" v-model="form.lotTracking" class="hidden peer">
                          <div class="relative toggle-bg  border-2  h-6 w-11 rounded-full" :class="form.lotTracking?'bg-theme-green border-theme-green':'bg-theme-red border-theme-red'"></div>
                        </label>
                      <span @click="form.lotTracking = true" :class="'cursor-pointer ml-2 text-sm font-medium ' + (form.lotTracking ? 'text-white' : 'text-theme-878686')"> On </span>
                    </div>
                </div>
            </div>
          </div>
          <div v-else class="xl:w-9/12"></div>

          <div  v-if="globalExemptScanner?.enableScannerVerification" class="xl:w-3/12">
            <div class="input-wrapper">
              <span class="text-xs">Exempt from Scanning</span>
              <label class="flex items-center cursor-pointer mt-1">
                  <input
                    type="checkbox"
                    v-model="form.exemptFromScanning"
                    class="hidden peer"
                  />
                  <div
                      class="relative toggle-bg border-2 h-6 w-11 rounded-full"
                      :class="
                        form.exemptFromScanning
                          ? 'bg-theme-green border-theme-green'
                          : 'bg-theme-red border-theme-red'
                      "
                  ></div>
                </label>
            </div>
          </div>
        </div>

        <div class="flex flex-row gap-5 mt-5">
          <div v-if="!form.isSubCategory" class="xl:w-4/12">
            <div class="w-full">
              <div class="input-wrapper">
                <span class="mb-0 text-xs">Visible Online</span>
                <div class="flex mt-1">
                  <span @click="form.online = false" :class="'cursor-pointer mr-2 text-sm font-medium ' + (form.online ? 'text-theme-878686' : 'text-white')"> Off </span>
                  <label class="flex items-center cursor-pointer">
                    <input type="checkbox" v-model="form.online" class="hidden peer">
                    <div class="relative toggle-bg  border-2  h-6 w-11 rounded-full" :class="form.online?'bg-theme-green border-theme-green':'bg-theme-red border-theme-red'"></div>
                  </label>
                  <span @click="form.online = true" :class="'cursor-pointer ml-2 text-sm font-medium ' + (form.online ? 'text-white' : 'text-theme-878686')"> On </span>
                </div>
              </div>
            </div>
          </div>
        </div>

      <div class="bg-theme-borderblack h-1 w-full my-4"></div>
      <div class="flex gap-3 xl:flex-row flex-col items-start mb-3">
          <div class="w-full">
              <div class="input-wrapper">
                  <label class="text-xs mb-1">Description</label>
                  <div class="flex">
                      <textarea v-model="form.description" placeholder="Write a description for the category" class="border-none block rounded bg-gray-black w-full text-sm"></textarea>
                  </div>
              </div>
          </div>
      </div>

      <div class="bg-theme-borderblack h-1 w-full my-4"></div>
      <div class="flex gap-3 xl:flex-row flex-col items-start mb-3" v-if="form.isSubCategory">
          <div class="w-full">
              <div :class="'input-wrapper ' + (form.parent.error_type)">
                  <label class="text-xs mb-1">Parent Category</label>
                  <div class="flex justify-between items-center">
                      <select @change="validateFields(['parent'])" v-model.number="form.parent.value" :class="'border-none block rounded bg-gray-black w-full text-sm '  + (form.parent.value != null ? 'text-white' : 'text-theme-878686')">
                          <option :value="null" disabled>-- Select --</option>
                          <option v-for="category in existingProductParentCategories" v-bind:key="'drop_cat'+ category.id" :value="category.id">
                              {{ category.name }}
                          </option>
                      </select>
                  </div>
                  <p class="field-error label-text mt-1" v-if="form.parent.error_message" v-text="form.parent.error_message"></p>
              </div>
          </div>
      </div>

      <div class="bg-theme-borderblack h-1 w-full my-4" v-if="form.isSubCategory"></div>

      <div class="flex gap-3 xl:flex-row flex-col items-start mb-3">
          <!-- <div class="xl:w-6/12 w-full">
              <div class="input-wrapper">
                  <label class="text-xs mb-1">Category Items</label>
                  <div class="flex justify-between items-center">
                      <span class="placeholder-white block bg-theme-modal_inner_bg pl-3 w-full focus:outline-0 text-sm text-theme-white border-none">0 items selected</span>
                      <div class="flex justify-between items-center">
                          <svg width="28" height="22" class="mr-4" viewBox="0 0 28 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M8.58268 21.0993L7.18268 19.6993L9.31602 17.4993C6.87157 17.4993 4.77713 16.666 3.03268 14.9993C1.28824 13.3327 0.416016 11.2771 0.416016 8.83268C0.416016 6.4549 1.24379 4.41602 2.89935 2.71602C4.5549 1.01602 6.57157 0.166016 8.94935 0.166016H14.016V2.16602H8.94935C7.12713 2.16602 5.58268 2.81602 4.31602 4.11602C3.04935 5.41602 2.41602 6.98824 2.41602 8.83268C2.41602 10.7216 3.11046 12.3049 4.49935 13.5827C5.88824 14.8605 7.54935 15.4993 9.48268 15.4993L7.28268 13.2993L8.68268 11.8993L13.216 16.466L8.58268 21.0993ZM16.816 17.4993V15.4993H27.0827V17.4993H16.816ZM16.816 9.83268V7.83268H27.0827V9.83268H16.816ZM16.016 2.16602V0.166016H27.0827V2.16602H16.016Z" fill="#2BA66B"/>
                          </svg>
                          <a href="#" class="bg-white p-2 rounded hover:bg-slate-300" @click.prevent="openCategoryModal()">
                              <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <path d="M6.3 19.1508L2.75 15.6008L3.8 14.5508L6.3 17.0258L10.775 12.5508L11.825 13.6258L6.3 19.1508ZM6.3 11.1508L2.75 7.60078L3.8 6.55078L6.3 9.02578L10.775 4.55078L11.825 5.62578L6.3 11.1508ZM13.75 17.2508V15.7508H22.75V17.2508H13.75ZM13.75 9.25078V7.75078H22.75V9.25078H13.75Z" fill="#2BA66B"/>
                              </svg>
                          </a>
                      </div>
                  </div>
              </div>
          </div> -->
          <!-- <div class="xl:w-6/12 w-full">
              <div class="input-wrapper">
                  <label class="text-xs mb-1">Recommendations</label>
                  <div class="flex justify-between items-center">
                      <span class="placeholder-white block bg-theme-modal_inner_bg pl-3 w-full focus:outline-0 text-sm text-theme-white border-none">0 items selected</span>
                      <div class="flex justify-between items-center">
                          <svg width="28" height="22" class="mr-4" viewBox="0 0 28 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M8.58268 21.0993L7.18268 19.6993L9.31602 17.4993C6.87157 17.4993 4.77713 16.666 3.03268 14.9993C1.28824 13.3327 0.416016 11.2771 0.416016 8.83268C0.416016 6.4549 1.24379 4.41602 2.89935 2.71602C4.5549 1.01602 6.57157 0.166016 8.94935 0.166016H14.016V2.16602H8.94935C7.12713 2.16602 5.58268 2.81602 4.31602 4.11602C3.04935 5.41602 2.41602 6.98824 2.41602 8.83268C2.41602 10.7216 3.11046 12.3049 4.49935 13.5827C5.88824 14.8605 7.54935 15.4993 9.48268 15.4993L7.28268 13.2993L8.68268 11.8993L13.216 16.466L8.58268 21.0993ZM16.816 17.4993V15.4993H27.0827V17.4993H16.816ZM16.816 9.83268V7.83268H27.0827V9.83268H16.816ZM16.016 2.16602V0.166016H27.0827V2.16602H16.016Z" fill="#2BA66B"/>
                          </svg>
                          <a href="#" class="bg-white p-2 rounded hover:bg-slate-300" @click.prevent="openRecommendCategoryModal()">
                              <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <path d="M6.3 19.1508L2.75 15.6008L3.8 14.5508L6.3 17.0258L10.775 12.5508L11.825 13.6258L6.3 19.1508ZM6.3 11.1508L2.75 7.60078L3.8 6.55078L6.3 9.02578L10.775 4.55078L11.825 5.62578L6.3 11.1508ZM13.75 17.2508V15.7508H22.75V17.2508H13.75ZM13.75 9.25078V7.75078H22.75V9.25078H13.75Z" fill="#2BA66B"/>
                              </svg>
                          </a>
                      </div>
                  </div>
              </div>
          </div> -->
      </div>


      <div class="flex gap-3 xl:flex-row flex-col items-start mb-3">
          <div class="w-full xl:w-3/4">
              <div :class="'input-wrapper ' + (form.posColour.error_type)">
                  <label class="text-xs mb-1">Color</label>
                  <div class="block rounded bg-gray-black w-full text-sm px-1 py-[5px]">
                      <label for="cp" class="w-full flex">
                        <input class="w-6 bg-transparent" @change="validateFields(['posColour'])" v-model="form.posColour.value" id="cp" type="color">
                        <span :class="'pl-2 items-center flex ' + (form.posColour.value ? 'text-white': 'text-theme-878686')">{{ form.posColour.value ? form.posColour.value : '-- Select --' }}</span>
                      </label>
                  </div>
                  <p class="field-error label-text mt-1" v-if="form.posColour.error_message" v-text="form.posColour.error_message"></p>
              </div>
          </div>
          <div class="w-full xl:w-3/4">
              <div :class="'input-wrapper ' + (form.ComplianceType.error_type)">
                  <label class="mb-0 text-xs">Compliance Type</label>
                  <select @change="validateFields(['ComplianceType'])" v-model="form.ComplianceType.value" :class="'block rounded bg-gray-black border-none w-full text-sm ' + (form.ComplianceType.value ? 'text-white' : 'text-theme-878686')">
                    <option value="" disabled>--Select--</option>
                    <option value="Dried flower">Dried flower</option>
                    <option value="Pre rolled">Pre rolled</option>
                    <option value="Extracts ingested">Extracts ingested</option>
                    <option value="Extracts inhaled">Extracts inhaled</option>
                    <option value="Edibles solids">Edibles solids</option>
                    <option value="Edibles non-solids">Edibles non-solids</option>
                    <option value="Topicals">Topicals</option>
                    <option value="Accessory">Accessory</option>
                  </select>
                  <p class="field-error label-text mt-1" v-if="form.ComplianceType.error_message" v-text="form.ComplianceType.error_message"></p>
              </div>
          </div>
          <div class="w-full xl:w-3/4">
            <div class="text-xs">Tax</div>
            <TaxSelectCheckbox v-model="categoryTaxes" :options="taxes" placeholder="Select" class="mt-2 block rounded bg-gray-black w-full border-none text-sm tracking-wider" :class="categoryTaxes.length>0?'text-white':'text-theme-878686'" />
          </div>
      </div>

      <div class="flex gap-3 xl:flex-row flex-col items-start mb-3">
          <div class="w-full xl:w-3/4">
              <div class="input-wrapper">
                  <label class="mb-0 text-xs">THC/CBD Values</label>
                  <label for="thc/cbd-togglestatus" class="flex relative items-center cursor-pointer px-1 py-1">
                      <input type="checkbox" value="range" id="thc/cbd-togglestatus" class="hidden peer">
                      <span @click="thcCbdValueTypeRange = false" :class="'mr-2 text-sm font-medium ' + (thcCbdValueTypeRange ? 'text-theme-878686' : 'text-white')"> Single </span>
                       <label class="flex items-center cursor-pointer">
                          <input type="checkbox" v-model="thcCbdValueTypeRange" class="hidden peer">
                          <div :class="'relative toggle-bg  border-2  h-6 w-11 rounded-full bg-theme-green border-theme-green'"></div>
                        </label>
                      <span @click="thcCbdValueTypeRange = true" :class="'ml-2 text-sm font-medium ' + (thcCbdValueTypeRange ? 'text-white' : 'text-theme-878686')"> Range </span>
                  </label>
              </div>
          </div>
          <div class="w-full xl:w-3/4">
              <div :class="'input-wrapper ' + (form.concentrationUnit.error_type)">
                  <label class="mb-0 text-xs">THC/CBD Unit</label>
                  <select @change="validateFields(['concentrationUnit'])" v-model="form.concentrationUnit.value" :class="'block rounded bg-gray-black border-none w-full text-sm ' + (form.concentrationUnit.value ? 'text-white' : 'text-theme-878686')">
                      <option value="" disabled>--Select--</option>
                      <option value="%">%</option>
                      <option value="mg/g">Mg/g</option>
                      <option value="mg/ml">Mg/Ml</option>
                      <option value="mg">Mg</option>
                      <option value="ml">Ml</option>
                      <option value="mg/bottle">Mg/bottle</option>
                      <option value="mg/pack">Mg/pack</option>
                      <option value="mg/unit">Mg/unit</option>
                  </select>
                  <p class="field-error label-text mt-1" v-if="form.concentrationUnit.error_message" v-text="form.concentrationUnit.error_message"></p>
              </div>
          </div>
          <!-- <div class="w-full xl:w-3/4">
              <div :class="'input-wrapper ' + (form.stockThreshold.error_type)">
                  <label class="text-xs mb-1">Min. Stock Threshold</label>
                  <input :onkeypress="preventNonNumbers"  @keyup="validateFields(['stockThreshold'])" v-model="form.stockThreshold.value" type="number" class="placeholder-white block rounded bg-gray-black border-none w-full text-sm text-theme-white">
                  <p class="field-error label-text mt-1" v-if="form.stockThreshold.error_message" v-text="form.stockThreshold.error_message"></p>
              </div>
          </div> -->
      </div>
  </div>

 </div>
</template>

<script lang="ts">
import {defineComponent, ref} from "vue"
import { mapGetters, mapActions, mapMutations } from "vuex";
import BusinessCategoryApis from "@/controllers/BusinessCategoryApis";
import LocationCannabisSettingApi from '@/controllers/LocationCannabisSetting';
import LocationPosStationApis from '@/controllers/LocationPosStationApis';
import { useSnackbar } from "vue3-snackbar";
import Helpers from '@/helpers';
import TaxSelectCheckbox from '@/components/form/CategorySelectCheckbox.vue'
import BusinessTaxApis from "@/controllers/BusinessTaxApis";

  export default defineComponent({
  name: "ProductCategoryAdd",
  components: {
    TaxSelectCheckbox
  },
  props: {
    clearComponent: {
      type: Function,
      required: true,
    },
  },

  setup() {
    const snackbar = useSnackbar();
    const locationTaxes = ref([]);
    const form = <any>ref({
      // businessId: '',
      isSubCategory: false,
      lotTracking: false,
      online: true,
      exemptFromScanning: false,
      parent: {
        value: null,
        error_type: '',
        error_message: '',
        validations: ['required_if:isSubCategory|true|string'],
      },
      name: {
        value: '',
        error_type: '',
        error_message: '',
        validations: ['required', 'min:3', 'max:30'],
      },
      description: "",
      ComplianceType: {
        value: '',
        error_type: '',
        error_message: '',
        validations: ['required'],
      },
      // stockThreshold: {
      //   value: 1,
      //   error_type: '',
      //   error_message: '',
      //   validations: ['required','positivenumber', 'maxval:500000'],
      // },
      posColour: {
        value: '#000000',
        error_type: '',
        error_message: '',
        validations: ['required'],
      },
      concentrationUnit: {
        value: '',
        error_type: '',
        error_message: '',
        validations: ['notrequired_multiple_if:ComplianceType|Non-cannabis|object'],
      },
      thcCbdValueType: "single"
    })
    const thcCbdValueTypeRange = ref(false);
    const existingProductParentCategories = <any>ref([]);
    const globalLotSetting = ref(false)
    const globalExemptScanner = ref({})
    const taxes = ref([])
    const categoryTaxes = ref([])

    return {
      snackbar,
      locationTaxes,
      form,
      thcCbdValueTypeRange,
      existingProductParentCategories,
      globalLotSetting,
      globalExemptScanner,
      taxes,
      categoryTaxes
    };
  },

  computed: {
    ...mapGetters({
      vg_activeBusiness: 'auth/activeBusiness',
      vg_selectedLocation: 'location/selected'
    }),
  },
  watch: {
    'thcCbdValueTypeRange'(value) {
      this.form.thcCbdValueType = value ? "range" : "single";
    },
    'form.isSubCategory'(value) {
      this.form.parent.value = value ? this.form.parent.value : null;
      if(value == false) {
        this.validateFields(['parent']);
      }
    }
  },

  async mounted() {
    this.fetchLotSetting();
    this.fetchExemptScannerSetting()
    this.fetchExistingProductCategories();
    this.fetchTaxes()
  },
 
  methods: {

    /**
     * Validation captures
     */
    async validateFields(fields) {
      let res = await Helpers.validateFormFields(this.form, fields);
      // capture the fields
      this.form = res.data;
      return res.error ? false : true;
    },

    /**
     * Fetch location lot setting
     */
    async fetchLotSetting(){
      let res = await LocationCannabisSettingApi.fetchSetting();
      // console.log(res.data.payload.lotTracking)
      this.globalLotSetting =  res.status == 200 ? res.data.payload.lotTracking : false;
    },



    /**
     * Fetch exempt scanning setting
     */
    async fetchExemptScannerSetting(){
        let res = await LocationPosStationApis.locationScannerVerification();
        this.globalExemptScanner =  res.status == 200 ? res.data.payload : {enableScannerVerification: false};
    },

    /**
     * Fetch existing categories
     */
    async fetchExistingProductCategories() {
      let res = await BusinessCategoryApis.fetchAllBusinessCategries({
        businessId: this.vg_activeBusiness.id, 
        page: 1, 
        perPage: 1000
      });  
      if(res.status == 200) {
        this.existingProductParentCategories = res.data.payload.category.filter(item => !item.parent);
      }
    },

    async fetchTaxes(){
        let res = await BusinessTaxApis.getTaxForBusiness(this.vg_activeBusiness.id)
        if(res.status==200){
          this.taxes = res.data.payload
        }
    },
 
 
    async addNewCategory() {
      // validate business field
      let validate = await this.validateFields(['name', 'parent', 'ComplianceType', 'posColour', 'concentrationUnit']);
      if(!validate) {
        return ;
      }

      // this.form.businessId = this.vg_activeBusiness.id;
      let data = <any>Helpers.getFormKeyValue(this.form);
      this.va_spinner(true);
      let res = await BusinessCategoryApis.addNewCategory(data);
      if(res.data.payload && this.vg_selectedLocation?.id){
        // update only if location selected
        await BusinessTaxApis.assignTaxToCategory(res.data.payload.id, {taxIds: this.categoryTaxes, locationId: this.vg_selectedLocation.id})
      }
      this.va_spinner(false);
      this.snackbar.add({
        type: 'info',
        text: res.status == 201 ? res.data.message : Helpers.catchErrorMessage(res.response.data),
        duration: 3000,
      })
      if(res.status == 201) {
        this.clearComponent()
         this.emitter.emit("refresh-business-categories-list", true);
      }
    },

    /**
     * Open category modal
     */
    openCategoryModal() {
      alert('waiting for api')
    },

    /**
     * Open category modal
     */
    openRecommendCategoryModal() {
      alert('waiting for api')
    },
    /**
     * Do not allow to add +,-,e
     */
    preventNonNumbers(e) {
       var ASCIICode = (e.which) ? e.which : e.keyCode
      if(ASCIICode == 43 || ASCIICode == 45 || ASCIICode == 101){
        return false;
      }
      return true;
    },
    ...mapActions({
      va_spinner: 'spinner/setSpinner',
    })
  },
});

</script>
